import { CEInterphaceBase } from './ce-interphace-base'


export class CEInterphace extends CEInterphaceBase {

}